import { render, staticRenderFns } from "./dishGroupBatch.vue?vue&type=template&id=3aee2a8d&scoped=true"
import script from "./dishGroupBatch.vue?vue&type=script&lang=js"
export * from "./dishGroupBatch.vue?vue&type=script&lang=js"
import style0 from "./dishGroupBatch.vue?vue&type=style&index=0&id=3aee2a8d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee2a8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aee2a8d')) {
      api.createRecord('3aee2a8d', component.options)
    } else {
      api.reload('3aee2a8d', component.options)
    }
    module.hot.accept("./dishGroupBatch.vue?vue&type=template&id=3aee2a8d&scoped=true", function () {
      api.rerender('3aee2a8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/dishGroupManage/dishGroupBatch.vue"
export default component.exports